import { useState } from "react";
import useAuth from "../../hooks/auth/useAuth";
import Logo from "../../assets/images/MahaTransco_logo.png";

import "./LoginPage.css";

function LoginPage({ onLogin }) {
const [email,setEmail] =useState("");
const [password,setPassword] =useState("");
const { login, loading } =useAuth();

const handleSubmit = async () => {

  if (!email || !password) {

    alert(
      "Please enter email and password"
    );

    return;
  }

  const response =
    await login(
      email,
      password
    );

  if (response.success) {

    window.location.reload();

  } else {

    alert(
      response.message
    );

  }
};

  return (
    <div className="network-page">

      {/* Background Network */}

      <div className="network-bg">

        <div className="node n1"></div>
        <div className="node n2"></div>
        <div className="node n3"></div>
        <div className="node n4"></div>
        <div className="node n5"></div>
        <div className="node n6"></div>
        <div className="node n7"></div>

        <div className="line l1"></div>
        <div className="line l2"></div>
        <div className="line l3"></div>
        <div className="line l4"></div>
        <div className="line l5"></div>
        <div className="line l6"></div>

      </div>

      {/* Main Content */}

      <div className="center-panel">

        <img
          src={Logo}
          alt="MAHATRANSCO"
          className="logo"
        />

        <div className="login-card">

          <h2>Welcome Back</h2>

          <p className="subtitle">
            Land Acquisition Monitoring System
          </p>

         <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e)=>
                setEmail(e.target.value)
            }
            />

            <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e)=>
                setPassword(e.target.value)
            }
            />
          <div className="remember-row">

            <label>
              <input type="checkbox" />
              Remember Me
            </label>

            <span>
              Forgot Password?
            </span>

          </div>

        <button
        onClick={handleSubmit}
        >
        {
            loading
            ? "Signing In..."
            : "Access Portal"
        }
</button>

        </div>

      </div>

    </div>
  );
}

export default LoginPage;